const EVENT = {
    load: 'DOMContentLoaded',
    delayed: 'Delayed',
    interactive: 'FirstInteractive',
}

class DelayScript extends HTMLElement {
    connectedCallback() {
        const url = this.getAttribute('url');
        const phase = this.getAttribute('phase') || "load";

        window.addEventListener(EVENT[phase], () => {
            setTimeout(() => this.load(url), 0);
        });
    }

    load(url) {
        const script = document.createElement("script");
        script.src = url;
        script.onload = () => this.dispatchEvent(new Event('load'));
        document.head.appendChild(script);
    }
}

customElements.define('delay-script', DelayScript);

class DelayStylesheet extends HTMLLinkElement {
    constructor() {
        super();

        window.addEventListener('DOMContentLoaded', () => {
            setTimeout(this.load, 0)
        })
    }

    connectedCallback() {
        this.rel = ''
    }

    load = () => {
        this.rel = 'stylesheet'
    }
}

customElements.define('delay-stylesheet', DelayStylesheet, { extends: 'link' });
